<!--
  - Copyright (c) 2020. Minerva Networks.
  - All rights reserved.
  -->

<template>
  <div class="Shadow">
    <div class="Modal animated" :class="modal.animation">
      <div v-if="modal.title" class="Modal__title">{{ modal.title }}</div>
      <div v-if="modal.text" class="Modal__text" v-html="modal.text"></div>
      <div v-if="modal.cta" class="Modal__cta" @click="exec(modal.callback)">
        <div class="Modal__cta__button">{{ modal.cta }}</div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapMutations, mapActions } from 'vuex';

export default {
  name: 'Modal',
  computed: {
    ...mapState(['modal']),
  },
  methods: {
    ...mapActions(['getMe', 'getPlans']),
    ...mapMutations(['initModal']),
    exec(cb) {
      this[cb]();
    },
    close() {
      this.initModal({ display: false });
    },
    closeAnPayWall() {
      const that = this;
      this.getMe()
        .then(() => {
          that.getPlans(true)
            .then(() => {
              that.$router.push('/paywall');
            })
            .catch(() => {
              window.app.$log.info('Unable retrive plans');
              that.$router.push('/paywall');
            })
            .then(() => {
              that.initModal({ display: false });
            });
        })
        .catch(() => {
          window.app.$log.info('Unable to retrive user info');
          that.$router.push('/paywall');
        });
    },
  },
};
</script>
